import React from 'react';
import { useIntl } from 'umi';
import classNames from 'classnames';
import { formatLimitCount } from '@/pages/dashboard/components/OverLimitTip/utils';
import { DEFAULT_LIMIT_COUNT } from '@/pages/dashboard/components/OverLimitTip/constants';
import type { IOverLimitInlineTipProps } from './type.d';

export const OverLimitInlineTip: React.FC<IOverLimitInlineTipProps> = ({
  className,
  style,
  limitCount,
  overLimitTipFormatRule,
  onDownload,
  linkClassName = 'dbd-over-limit-inline-tip__link',
  config,
}) => {
  const { formatMessage } = useIntl();
  const {
    prefixText = formatMessage({ id: 'dbd_over_limit_tip_prefix' }, { count: formatLimitCount(limitCount ?? DEFAULT_LIMIT_COUNT, overLimitTipFormatRule) }),
    linkText = formatMessage({ id: 'dbd_over_limit_tip_link' }),
    suffixText = formatMessage({ id: 'dbd_over_limit_tip_suffix' }),
  } = config || {};

  return (
    <span className={classNames('dbd-over-limit-inline-tip', className)} style={style}>
      <span>{prefixText}</span>
      {' '}
      <span className={linkClassName} onClick={onDownload}>
        {linkText}
      </span>
      {' '}
      <span>{suffixText}</span>
    </span>
  );
};

